

export class GetVehicleDetailsOutputData implements IGetVehicleDetailsOutputData {
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle odometer reading */
    odometer!: number;
    /** The vehicle final total kilometer reading */
    final_total_km!: number;

    constructor(data?: IGetVehicleDetailsOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.odometer = _data["odometer"];
            this.final_total_km = _data["final_total_km"];
        }
    }

    static fromJS(data: any): GetVehicleDetailsOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new GetVehicleDetailsOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["odometer"] = this.odometer;
        data["final_total_km"] = this.final_total_km;
        return data; 
    }
}

export interface IGetVehicleDetailsOutputData {
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id: number;
    /** The vehicle odometer reading */
    odometer: number;
    /** The vehicle final total kilometer reading */
    final_total_km: number;
}

